import { mapState, mapActions } from 'vuex';
import gridMixin from '../grid.mixin';
import {
  findVisualAnchorPoint,
  getVisualAnchorTimes,
  CursorManager,
} from '../../api/tapi';
import _ from 'lodash-extended';
import { VisualGhostMode } from '../../api/model';
import tmBus from '../../api/tmBus';

export default {
  mixins: [gridMixin],

  computed: {
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      MODE_OPTIONAL_AUDIO_INSERT: (state) => state.MODE.OPTIONAL_AUDIO_INSERT,
      MODE_AUDIO_MULTISELECT: (state) => state.MODE.AUDIO_MULTISELECT,
      trackLayer: (state) => state.trackLayer,
    }),

    moveObj() {
      return {
        enabled: this.trackLayer.visual.length > 1 && !this.MODE_SCENE_EDIT,
        distance2trigger: this.CONST.DND_SENSITIVITY.DEFAULT,
        onMoveStart: this.$_onMoveStart,
        onMove: this.$_onMove,
        onMoveEnd: this.$_onMoveEnd,
      };
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'SET_MODE',
      'SET_DND_ESCORT',
      'SET_SECONDHAND',
      'REMOVE_VISUAL',
      'INSERT_VISUAL_TRACK',
      'UNSELECT_TRACKS',
      'SELECT_VISUAL',
      'MANAGED_AUDIO_INSERT_EXIT',
      'AUDIO_MULTISELECT_EXIT',
    ]),

    $_onMoveStart(state) {
      if (this.MODE_OPTIONAL_AUDIO_INSERT) {
        this.MANAGED_AUDIO_INSERT_EXIT();
      }
      if (this.MODE_AUDIO_MULTISELECT) {
        this.AUDIO_MULTISELECT_EXIT();
      }

      this.SET_MODE({ name: 'VISUAL_DND', value: true });
      state.mousePoint = this.$_mouse2point(state.eDown);
      const track = this.$_time2visualTrack(state.mousePoint.time);

      this.UNSELECT_TRACKS();
      this.REMOVE_VISUAL(track);
      this.SET_DND_ESCORT({ name: 'showVisualAnchors', value: true });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: true });
      this.SET_DND_ESCORT({ name: 'trackInHand', value: track });

      state.displayStartTime = track.data.displayStartTime;
      state.insertionTime = track.data.displayStartTime;

      state.aTimes = getVisualAnchorTimes(this.trackLayer.visual);
      state.proximityTester = this.$_createProximityTester(
        state.aTimes,
        this.CONST.AUTOSNAP_PROXIMITY.ASSET
      );

      tmBus.$emit('callbackBeforeDragStarts');
      CursorManager.set('grabbing');
    },

    $_defineGhostMode(state) {
      if (null !== state.insertionTime) {
        const index = state.aTimes.indexOf(state.insertionTime);
        if (
          _.between(0, index, state.aTimes.length - 1, {
            includeMin: false,
            includeMax: false,
          })
        ) {
          this.$data.mode = VisualGhostMode.INSERT_BETWEEN;
        } else if (!state.outerSpace) {
          this.$data.mode = VisualGhostMode.INSERT;
        } else {
          this.$data.mode = null;
        }
      } else {
        this.$data.mode = null;
      }
    },

    $_onMove(state) {
      state.mousePoint = this.$_mouse2point(state.eMove, state.mousePoint);
      const searchResult = findVisualAnchorPoint(
        state.proximityTester,
        state.mousePoint.time
      );
      state.insertionTime = searchResult.time;
      state.outerSpace = searchResult.outerSpace;

      this.$data.ghostPoint.assign(state.mousePoint);

      this.SET_DND_ESCORT({
        name: 'insertionTime',
        value: state.insertionTime,
      });

      this.$_defineGhostMode(state);
    },

    $_onMoveEnd(state) {
      CursorManager.restore();

      let isChanged = true;
      if (state.canceled || null === state.insertionTime) {
        state.insertionTime = state.displayStartTime;
        isChanged = false;
      }

      this.INSERT_VISUAL_TRACK({
        time: state.insertionTime,
        track: this.trackInHand,
      });
      this.SELECT_VISUAL({ track: this.trackInHand });
      this.SET_DND_ESCORT({ name: 'trackInHand', value: null });
      this.SET_DND_ESCORT({ name: 'insertionTime', value: null });
      this.SET_DND_ESCORT({ name: 'showVisualAnchors', value: false });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: false });
      this.SET_MODE({ name: 'VISUAL_DND', value: false });

      if (isChanged) {
        tmBus.$emit('callbackChange', {
          e: state.eUp,
          seekToTime: state.insertionTime + 0.001,
        });
      }
    },
  },
};
